<template>
    <div v-if="props.inside" class="inside">
        <svg viewBox="10 0 1600 1" fill="none" version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            :stroke="insideStroke"
            stroke-width="3"
        >
            <linearGradient :id="id" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" :stop-color="insideColors[0]" />
                <stop offset="50%" :stop-color="insideColors[1]" />
                <stop offset="100%" :stop-color="insideColors[2]" />
            </linearGradient>
          <path 
            :fill="`url(#${id})`" 
            d="
              M0 67
              C 273,183
                822,-40
                1920.00,106 
              
              V 359 
              H 0 
              V 67
              Z">

            <animate 
                repeatCount="indefinite" 
                :fill="`url(#${id})`" 
                attributeName="d" 
                dur="3s"
                attributeType="XML"
                values="
                    M0 77 
                    C 473,283
                      822,-40
                      1920,116 
                    
                    V 359 
                    H 0 
                    V 67 
                    Z; 

                    M0 77 
                    C 473,-40
                      1222,283
                      1920,136 
                    
                    V 359 
                    H 0 
                    V 67 
                    Z; 

                    M0 77 
                    C 973,260
                      1722,-53
                      1920,120 
                    
                    V 359 
                    H 0 
                    V 67 
                    Z; 

                    M0 77 
                    C 473,283
                      822,-40
                      1920,116 
                    
                    V 359 
                    H 0 
                    V 67 
                    Z
                ">
            </animate>
          </path>
        </svg>
    </div>

    <ul v-else :class="props.class">
        <li><Icon icon="logo"/></li>
        <li><Icon icon="logo"/></li>
        <li><Icon icon="logo"/></li>
        <li><Icon icon="logo"/></li>
    </ul>
</template>

<script setup>
    import { code } from '🔗/utils/utils';
    import { computed } from 'vue';

    const props = defineProps({
        class: { type: String, default: '' },
        inside: { type: Boolean, default: false }
    });

    const id = `grad-${code()}`;


    const insideStroke = computed(() => {
        if (!props.inside) {
            return [];
        }

        const invert = props.class?.indexOf('invert') !== -1;

        if (props.class.indexOf('secondary') !== -1) {
            return invert ? 'var(--white-500)' : 'var(--primary-500)';
        }

        if (props.class.indexOf('tertiary') !== -1) {
            return invert ? 'var(--white-500)' : 'var(--primary-500)';
        }

        return 'none';
    })

    const insideColors = computed(() => {
        if (!props.inside) {
            return [];
        }

        if (props.class.indexOf('secondary') !== -1) {
            return ['var(--light-10)', 'var(--light-20)', 'var(--light-10)'];
        }

        if (props.class.indexOf('tertiary') !== -1) {
            return ['transparent', 'transparent', 'transparent'];
        }
        

        return ['var(--primary-500)', 'var(--primary-700)', 'var(--primary-500)'];
    });
</script>

<style lang="scss" scoped>
    .inside {
        display: flex;
        flex: 1 1 100%;
        width: 100%;
        height: 100%;
        min-width: 60px;

        svg {
            position: absolute;
            left: -30%;
            bottom: 0;
            width: 300%;
            height: 200%;
            animation-name: move-left;
            animation-duration: 3s;
            animation-iteration-count: infinite;
            animation-direction: alternate;
        }
    }

    @keyframes move-left {
        0% {
            left: 0px;
            bottom: 0px;
        }
        50% {
            left: -200%;
            bottom: 0px;
        }
        100% {
            left:0px; 
            bottom: 0px;
        }
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        pointer-events: none;
        background: var(--white-500);

        &:after {
            position: absolute;

            background-image: linear-gradient(222deg, var(--dark-500) 17px, transparent 18px), linear-gradient(45deg, var(--dark-500) 17px, transparent 18px);
            background-size: 50px 50px;
            background-repeat: repeat;

            content: "";
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            animation: bilbo-loader infinite 20s;
        }

        @keyframes bilbo-loader {
            0% {
                background-position-x: 0%;
                background-position-y: 0%;
            }
            100% { 
                background-position-x: 100%;
                background-position-y: 100%;
            }
        }

        li {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 2;
            animation: svg 24s infinite;
            svg {
                width: 120px;
                height: auto;
                fill: none;
                shape-rendering: geometricPrecision;
                text-rendering: geometricPrecision;
                image-rendering: optimizeQuality;
                fill-rule: evenodd;
                clip-rule: evenodd;
            }

            &:nth-child(1) {
                svg {
                    fill: var(--dark-20);
                    stroke: var(--dark-80);
                    animation: line-3-svg 4s infinite;
                }
            }
            &:nth-child(2) {
                svg {
                    fill: var(--dark-10);
                    stroke: var(--dark-20);
                    animation: line-2-svg 4s infinite;
                }
            }
            &:nth-child(3) {
                svg {
                    fill: var(--dark-10);
                    stroke: var(--dark-10);
                    animation: line-1-svg 4s infinite;
                }
            }
            &:nth-child(4) {
                svg {
                    stroke-width: 1px;
                    fill: var(--dark-80);
                    animation: base-svg 4s infinite;
                }
            }
        }

        &.light {
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 400; // Разобраться с ними
            &:after {
                background-image: linear-gradient(222deg, var(--light-20) 37px, transparent 38px), linear-gradient(145deg, var(--light-10) 37px, transparent 38px);
                animation: bilbo-loader infinite 8s;
            }

            li {
                svg {
                    width: 60px;
                }
            }
        }

        &.lightest {
            background: none;
            animation: none;
            &:after {
                display: none;
            }

            li {
                // top: 50%;
                // height: 50%;
                svg {
                    width: 40px;
                }
            }
        }

        &.opacity-mode {
            background: none;
            animation: none;
            &:after {
                display: none;
            }

            li {
                top: 50%;
                height: 50%;
                svg {
                    width: 80px;
                }
            }
        }
    }

    @keyframes base-svg {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }

    @keyframes line-1-svg {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            transform: scale(1.6);
            opacity: .6;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

    @keyframes line-2-svg {
        0% {
            transform: scale(1);
            opacity: .8;
        }
        50% {
            transform: scale(2);
            opacity: .4;
        }
        100% {
            transform: scale(1);
            opacity: .8;
        }
    }

    @keyframes line-3-svg {
        0% {
            transform: scale(1);
            opacity: .6;
        }
        50% {
            transform: scale(2.4);
            opacity: .2;
        }
        100% {
            transform: scale(1);
            opacity: .6;
        }
    }

    @keyframes svg {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>












